import { Button, Modal } from "@mui/material";
import React, { useState, useCallback, useLayoutEffect } from "react";
import Cropper from "react-easy-crop";
import { getOrientation } from "get-orientation/browser";
import { getCroppedImg, getRotatedImage } from "./canvasUtils";
import axios from "axios";
import addImage from "../../assets/image/addImage.jpeg";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const ORIENTATION_TO_ANGLE = {
  3: 180,
  6: 90,
  8: -90,
};

function useForceUpdate() {
  let [value, setState] = useState(true);
  return () => setState(!value);
}

const CropMultipleImage = (props) => {
  const [imageIds, setImageIds] = useState([]);
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [open, setOpen] = useState(false);
  const [type, setType] = useState("");
  const [name, setName] = useState("");
  const [progress, setprogress] = useState(0);
  const [progressDisplay, setprogressDisplay] = useState("");
  const [image, setImage] = useState([]);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);
  const handleForceupdateMethod = useForceUpdate();

  useLayoutEffect(() => {
    if (
      props.pageType === "edit" &&
      props.inputData[props.item.key].length > 0
    ) {
      getImage();
    }
  }, [props.pageType]);

  async function getImage() {
    let array2 = imageIds;
    const fetchingUrl = props.inputData[props.item.key].map(
      (url) => props.item.get + url,
    );

    axios
      .all(
        fetchingUrl.map((endpoint) =>
          axios.get(endpoint, {
            responseType: "blob",
          }),
        ),
      )
      .then((res) => {
        res.map((item) => {
          const id = item.request.responseURL.split("/").at(-1);
          var reader = new window.FileReader();
          reader.readAsDataURL(item.data);
          reader.onload = function (e) {
            setImage((prevState) => [...prevState, reader.result]);
            array2.push(id);
            if (props.HasManyInputData) {
              props.HasManyInputData(props.index, props.HasManyKey, array2);
            } else {
              let object = props.inputData;
              object[props.keyValue] = array2;
              props.setInputData(object);
            }
          };
        });
      })
      .then(() => {
        setImageIds(array2);
      });
  }

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        imageSrc,
        croppedAreaPixels,
        rotation,
        type,
      );
      file(croppedImage.blob);
    } catch (e) {
      console.error(e);
    }
  }, [imageSrc, croppedAreaPixels, rotation]);

  const onFileChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      let imageDataUrl = await readFile(file);
      setType(e.target.files[0].type);
      setName(e.target.files[0].name);
      try {
        const orientation = await getOrientation(file);
        const rotation = ORIENTATION_TO_ANGLE[orientation];
        if (rotation) {
          imageDataUrl = await getRotatedImage(imageDataUrl, rotation);
        }
      } catch (e) {
        console.warn("failed to detect the orientation");
      }
      setImageSrc(imageDataUrl);
      handleOpen();
    }
  };

  function file(url) {
    setprogress(0);
    let array2 = image;
    array2.push(url);
    setImage(array2);
    setprogressDisplay(url);
    fetch(url)
      .then((res) => res.blob())
      .then((blob) => {
        const file = new File([blob], name, { type: `${type}` });
        const formData = new FormData();
        formData.append("image", file);
        formData.append("type", props.imageType);
        axios
          .post(
            props.item.store,
            formData,
            {
              onUploadProgress: (progressEvent) => {
                const percentage = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total,
                );
                setprogress(percentage);
              },
            },
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            },
          )
          .then((res) => {
            let array = imageIds;
            array.push(res.data.data.id);
            setImageIds(array);
            if (props.HasManyInputData) {
              props.HasManyInputData(props.index, props.HasManyKey, array);
            } else {
              let object = props.inputData;
              object[props.keyValue] = array;
              props.setInputData(object);
            }
            // let array2 = image;
            // let object2 = {};
            // object2.url = url;
            // object2.id = res.data.data.id;
            // array2.push(object2);
            // setImage(array2);
            handleForceupdateMethod();
            setprogressDisplay("");
          });
      });
  }

  function minus(params) {
    if (zoom >= 1.5) {
      setZoom(zoom - 0.5);
    } else if (zoom > 1 && zoom < 1.5) {
      setZoom(1);
    }
  }

  function plus(params) {
    if (zoom <= 2.5) {
      setZoom(zoom + 0.5);
    } else if (zoom < 3 && zoom > 2.5) {
      setZoom(3);
    }
  }
  function deleteImage(event) {
    const imageArr = image;
    const index = imageArr.findIndex(
      (obj) => obj.url === event.currentTarget.id,
    );
    imageArr.splice(index, 1);
    setImage(imageArr);
    let idsArr = imageIds;
    idsArr.splice(index, 1);
    setImageIds(idsArr);
    handleForceupdateMethod();
  }

  return (
    <div className="col-span-full sm:col-auto">
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="w-[80%] 450:w-[60%] 560:w-[50%] m-auto h-[300px] md:h-[350px] md:w-[40%] lg:w-[35%] xl:w-[30%] xl:h-[400px] 1440:w-[30%] 1440:h-[500px] bg-white "
      >
        <div>
          <div className="">
            <Cropper
              image={imageSrc}
              crop={crop}
              rotation={rotation}
              zoom={zoom}
              aspect={
                props.item.width && props.item.height
                  ? Number(props.item.width) / Number(props.item.height)
                  : 1 / 1
              }
              onCropChange={setCrop}
              onRotationChange={setRotation}
              onCropComplete={onCropComplete}
              onZoomChange={setZoom}
            />
          </div>
          <div
            className={
              "absolute  bottom-[-100px] w-full bg-white items-center px-2 pb-2 rounded-b-[10px]"
            }
          >
            <div className={"flex p-2 gap-2 items-center justify-around"}>
              <div className=" flex justify-between items-center my-2 h-[30px]">
                <button
                  className="w-[100px] h-[40px] border rounded-r-[20px]"
                  onClick={minus}
                >
                  <i className="fa fa-search-minus"></i>
                </button>
                <button
                  className="w-[100px] h-[40px] border rounded-l-[20px]"
                  onClick={plus}
                >
                  <i className="fa fa-search-plus"></i>
                </button>
              </div>
            </div>
            <div className="px-[15%]">
              <Button
                onClick={() => {
                  showCroppedImage();
                  handleClose();
                }}
                variant="contained"
                color="primary"
                className="modalButton"
              >
                <span className="my-[5px] text-lg">ثبت</span>
              </Button>
            </div>
          </div>
        </div>
      </Modal>
      <div className="grid grid-cols-3 450:grid-cols-4 lg:grid-cols-5 gap-y-3 gap-x-3 w-full">
        <div className="w-full relative">
          <input
            className="opacity-0 absolute top-0 h-full cursor-pointer w-full"
            type="file"
            onChange={onFileChange}
            accept="image/*"
            disabled={props.item.disabled}
          />
          <img
            src={addImage}
            key={"input"}
            className=" rounded-md border-dashed border-2 border-[#5ba9aa] p-1 "
            alt=""
          />
        </div>
        {image &&
          image.map((item, index) => (
            <div className="relative" key={index}>
              {progressDisplay === item && (
                <div
                  className={`absolute z-[10] rounded-md p-5 m-1 top-0 right-0 bg-[#0000005b]`}
                >
                  <CircularProgressbar value={progress} text={`${progress}%`} />
                </div>
              )}
              <img
                src={item}
                id={item}
                key={index}
                className=" rounded-md border-dashed border-2 border-[#5ba9aa] p-1 "
                alt=""
              />
              <div
                className="absolute top-2 right-2 bg-[#ffffff81] w-6 h-6 flex items-center justify-center rounded-sm cursor-pointer text-xl"
                onClick={deleteImage}
                id={item}
              >
                <i className="fa fa-trash-o text-red-600 "></i>
              </div>
            </div>
          ))}
      </div>
      <div className="mt-2 text-[.8rem] text-edit_input_validation">
        {props.error}
      </div>
    </div>
  );
};

function readFile(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => resolve(reader.result), false);
    reader.readAsDataURL(file);
  });
}

const StyledDemo = CropMultipleImage;
export default StyledDemo;
